/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  

  /* ====== Video Loader Func ====== */

  var videoLoader = function(videoLoaderElm) {
    var video = $(videoLoaderElm);
    if (video.is(':visible')) {
        $('source', video).each(
            function() {
              const el = $(this);
              el.attr('src', el.data('src'));
            }
          );
      video.each(function(_index, element) {
        element.load();
      });
    }
  }


  videoLoader('.video-wrapper video');
  videoLoader('.video-wrapper-mob video');

  $('.featured-video__audio-control-btn button').on('click', function () {
    let windowWidth = $(window).width();
    const isOn = $(this).hasClass('on');
    const videoWrapperClass = (windowWidth > 767) ? '.video-wrapper video' : '.video-wrapper-mob video';
    const videoElm = $(this).closest('.featured-video-section').find(videoWrapperClass);
  
    if (isOn) {
      $(this).removeClass('on').addClass('off');
      $(this).find('i').addClass('muted-icon').removeClass('up-icon');
      videoElm.prop('muted', true);
    } else {
      $(this).removeClass('off').addClass('on');
      $(this).find('i').removeClass('muted-icon').addClass('up-icon');
      if (videoElm[0].paused) {
        videoElm[0].controls = false;
        videoLoader(videoWrapperClass);
      }
      videoElm.prop('muted', false);
    }
  });  


  /* ====== VIDEO SECTION ====== */

 function videoFixed() {
    document.querySelectorAll('.featured-video-section').forEach(function(videoSection) {
      const rect = videoSection.getBoundingClientRect();
      const video = videoSection.querySelector(".video-wrapper video");
      const windowHeight = window.innerHeight;

      if ((rect.top >= 0 && rect.top <= windowHeight) || 
        (rect.bottom >= 0 && rect.bottom <= windowHeight) ||
        (rect.top <= 0 && rect.bottom >= windowHeight)) {
        video.style.cssText = "position: fixed; top: 0;";
      } else {
        video.style.cssText = "position: absolute; top: unset;";
      }
    });
  }
  

  /* ====== Header logo size ====== */

  if (window.location.pathname === '/'){
    var firstSection = document.querySelector("#MainContent .shopify-section");
    if ( firstSection.classList.contains("featured-video-section") === true ){
      document.querySelector(".logo__image-link.logo__image-link--home").style.cssText = "width: 450px; height: auto; max-width: 450px;";
    }
  
    var bottomFirstSection = firstSection.offsetTop + firstSection.offsetHeight - 180;
    
    window.addEventListener('scroll',(event) => {
      var topPage = window.scrollY;
      var bottomPage = (window.scrollY + window.innerHeight);
      if ( topPage > bottomFirstSection ){
        var height = topPage - bottomFirstSection;
        var widthLogo = 380 - height;
        if ( widthLogo > 110 ){
          document.querySelector(".logo__image-link.logo__image-link--home").style.cssText = "width: "+ widthLogo +"px; height: auto; max-width: "+ widthLogo +"px;";
        }else{
          document.querySelector(".logo__image-link.logo__image-link--home").style.cssText = "width: 110px; height: auto; max-width: 110px;";
        }
      }
      videoFixed();
    });
  }




const menuItems = document.querySelectorAll('.menu__item[aria-haspopup="true"]');

menuItems.forEach(menuItem => {
  const dropdown = menuItem.querySelector('.header__dropdown');
  const overlay = menuItem.querySelector('.header__dropdown_overlay');
  const closeButton = menuItem.querySelector('.drawer__close-button');
  let hoverTimeout;

  // Hover behavior
  menuItem.addEventListener('mouseenter', () => {
    hoverTimeout = setTimeout(() => {
      menuItem.setAttribute('no-before', '');
    }, 2000);
  });

  menuItem.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimeout);
    menuItem.removeAttribute('no-before');
  });

  if (dropdown) {
    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      menuItem.setAttribute('no-before', '');
    });

    dropdown.addEventListener('mouseleave', () => {
      menuItem.removeAttribute('no-before');
    });
  }

  // 🔹 Function to update <body> scroll lock
  const updateBodyScroll = () => {
    const anyOpen = document.querySelector('.menu__item.grandparent.is-visible[aria-expanded="true"]');
    document.body.style.overflow = anyOpen ? 'hidden' : '';
  };

  // 🔹 Close menu function
  const closeMenu = () => {
    if (menuItem.classList.contains('is-visible') && menuItem.getAttribute('aria-expanded') === 'true') {
      menuItem.classList.remove('is-visible');
      menuItem.setAttribute('aria-expanded', 'false');
      updateBodyScroll();
    }
  };

  // Close when clicking overlay
  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Close when clicking close button
  if (closeButton) {
    closeButton.addEventListener('click', closeMenu);
  }

  // (Optional) If you also *open* menus via JS, call updateBodyScroll() there too
});

// 🔹 In case menus are opened by CSS hover or another script,
// you can observe changes and keep <body> updated
const observer = new MutationObserver(() => {
  const anyOpen = document.querySelector('.menu__item.grandparent.is-visible[aria-expanded="true"]');
  document.body.style.overflow = anyOpen ? 'hidden' : '';
});

observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-expanded'] });


  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

})();












window.theme = window.theme || {};

document.addEventListener('DOMContentLoaded', function() {
  const checkThemeSections = setInterval(function() {
    if (window.theme && window.theme.sections && window.theme.sections.register) {
      theme.sections.register('complementary-products', {
        onLoad() {
          
          this.container = this.container;
          this.productId = this.container.getAttribute('data-product-id');
          this.sectionId = this.container.getAttribute('data-section-id');
          this.productContainer = this.container.querySelector('[data-complementary-products]');

          if (this.productId && this.productContainer) {
            this.loadRecommendations();
          }
        },

        loadRecommendations() {
          const baseUrl = window.Shopify.routes.root + 'recommendations/products';
          const url = `${baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=4`;

          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;

              const recommendations = html.querySelector('[data-complementary-products]');
              
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.productContainer.innerHTML = recommendations.innerHTML;
                
                // Initialiser les composants après le chargement
                this.productGrid = new theme.ProductGridEvents(this.container);
                this.quickView = new theme.QuickViewPopup(this.container);
              }
            })
            .catch(e => {
              console.warn('Error loading recommendations:', e);
            });
        },

        onUnload() {
          if (this.productGrid) {
            this.productGrid.onUnload();
          }
          if (this.quickView) {
            this.quickView.onUnload();
          }
        }
      });
      clearInterval(checkThemeSections);
    }
  }, 100);
});








